import { all, fork } from "redux-saga/effects";

import adminSession from "./adminSession";
import assessmentSession from "./assessmentSession";
import botpressSession from "./botpressSession";
import creatorSession from "./creatorSession";
import nmhaSession from "./nmhaSession";
import onboardingSession from "./onboardingSession";
import partnerSession from "./partnerSession";
import patientSession from "./patientSession";
import practiceSession from "./practiceSession";
import providerSession from "./providerSession";
import searchSession from "./searchSession";
import trialSession from "./trialSession";
import userSession from "./userSession";

const sagas = [
  adminSession,
  onboardingSession,
  userSession,
  nmhaSession,
  patientSession,
  trialSession,
  assessmentSession,
  partnerSession,
  practiceSession,
  providerSession,
  creatorSession,
  searchSession,
  botpressSession,
];

export default function* rootSaga() {
  yield all(sagas.map(saga => fork(saga)));
}
